import { createAction } from '@reduxjs/toolkit'
import { Video, VideoPlayer } from '../../../models/interfaces/video.interface'

export const setSelectedVideo = createAction<Video | null>(
  'modalPlayer/setSelectedVideo'
)

export const setVideoPlayer = createAction<VideoPlayer>('modalPlayer/setStartPlay')
export const setIsVisible = createAction<boolean>('modalPlayer/setIsVisible')
